<template>
    <div :id="ldTableId">
        <ld-fullscreen-expansion
            :class="{ 'in-table': expanded }"
            :disabled="!expanded">

            <vs-card class="ld-table">
                <ld-fullscreen-toggle-expand-button
                    v-if="expanded"
                    :expandedElementWrap="parentId"
                    :expandedElementId="'#' + ldTableId"
                    :class="ldTableId"
                />

                <div :class="{'fullscrreen-expansion-scroll': expanded }">
                    <div class="td-table-header flex flex-wrap justify-between items-center pt-12">
                        <div class="flex flex-wrap justify-start items-end mb-4 mr-8">
                            <vs-dropdown v-if="count !== null" vs-trigger-click class="cursor-pointer mr-8">
                                <div
                                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                                >
                                    <span
                                        class="mr-2"
                                    >{{ !count ? 0 : pagination.currentPage * pagination.pageSize - (pagination.pageSize - 1) }} - {{ pagination.pageSize > count ? count : pagination.currentPage * pagination.pageSize }} de {{ !count ? 0 : count }}</span>
                                    <!-- <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> -->
                                </div>
                                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                                <vs-dropdown-menu class="dropdown-table-page" :class="$el.id + '-dropdown-table-page'">
                                    <vs-dropdown-item @click="setPageSize(10)">
                                        <span>10</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="setPageSize(20)">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="setPageSize(50)">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="setPageSize(100)">
                                        <span>100</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="setPageSize(200)">
                                        <span>200</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="setPageSize(500)">
                                        <span>500</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>

                            <div v-if="columnDefs && count !== null" class="filter-column mr-4">
                                <ld-select-checkbox
                                    label="Filtrar colunas da tabela"
                                    :model.sync="filterColumn"
                                    :list.sync="columnFilterList"
                                    :selectMultiple="onToggleMultipleColumns"
                                    :select="onToggleSingleColumn"
                                />
                            </div>

                            <div v-if="count !== null" class="button-clear-filter mr-4">
                                <ld-button
                                    :disabled="!hasFilter"
                                    class="button-filter button-border"
                                    type="border"
                                    color="dark"
                                    @click="resetFilter"
                                >Limpar filtros</ld-button>
                            </div>
                        </div>

                        <div class="table-slot">
                            <slot/>
                        </div>
                    </div>

                    <div class="ld-table-content" :class="{'loading-data': !data || (data && !data.length)}">
                        <table v-show="!firstLoading" class="table-resizable">
                            <thead>
                                <tr class="row-column-headings">
                                    <th
                                        v-for="(columnDef, index) in columnDefs"
                                        :key="index"
                                        @click="setSort(filtersFields[columnDef.field] || columnDef.field)"
                                        :style="columnDef.style"
                                        class="th-column-headings"
                                        :class="[filterColumnPrefix + removeWhiteSpace(columnDef.field), setColumnVisibility(columnDef)]"
                                    >
                                        <div class="thead-th-content">
                                            <p>{{ columnDef.headerName }}</p>
                                            <i
                                                class="vs-icon icon-scale feather text-xl ml-2 icon-order"
                                                :class="{
                                                    'icon-arrow-up': sortData[filtersFields[columnDef.field] || columnDef.field] === (filtersFields[columnDef.field] || columnDef.field),
                                                    'icon-arrow-down': sortData[filtersFields[columnDef.field] || columnDef.field] === '-' + (filtersFields[columnDef.field] || columnDef.field),
                                                }"
                                            ></i>
                                            <span class="resize-area"></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr class="row-filters" v-show="hasFilterColumns">
                                    <th
                                        v-for="(columnDef, index) in columnDefs"
                                        :key="index"
                                        :style="columnDef.style"
                                        :class="[filterColumnPrefix + removeWhiteSpace(columnDef.field), setColumnVisibility(columnDef), columnDef.filterStyleClasses]"
                                    >
                                        <div class="thead-th-content">
                                            <div v-if="columnDef.filter === false"></div>

                                            <div
                                                :id="'customFilter' + (filtersFields[columnDef.field] || columnDef.field)"
                                                v-else-if="columnDef.customFilter"></div>


                                            <div v-else-if="columnDef.filter === 'selectCheckbox'">
                                                <ld-select-checkbox
                                                    :name="columnDef.field"
                                                    :model.sync="filtersData[filtersFields[columnDef.field] || columnDef.field]"
                                                    :list.sync="columnDef.filterSelectData"
                                                    :minChecked="0"
                                                />
                                            </div>

                                            <div v-else-if="columnDef.filter === 'select'">
                                                <ld-select
                                                    parent=".ld-table-content"
                                                    :name="columnDef.field"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    :model.sync="filtersData[filtersFields[columnDef.field] || columnDef.field]"
                                                    :list.sync="columnDef.filterSelectData"
                                                />
                                            </div>

                                            <div v-else>
                                                <vs-input
                                                    :name="columnDef.field"
                                                    icon-pack="feather"
                                                    icon="icon-search"
                                                    icon-after="true"
                                                    v-model="filtersData[filtersFields[columnDef.field] || columnDef.field]"
                                                />
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                            <transition name="fade-down">
                            <tbody v-show="data && data.length">
                                <tr
                                    :id="'index' + itemIndex"
                                    @click="selectItem(item)"
                                    v-for="(item, itemIndex) in data"
                                    :key="itemIndex"
                                    class="no-click"
                                    :class="{'click': configsDetail || handlerClickItem, ...trCustomClasses(item)}">

                                    <td
                                        :class="[
                                            columnDef.field,
                                            filterColumnPrefix + removeWhiteSpace(columnDef.field),
                                            setColumnVisibility(columnDef),
                                            {'border-b-0': itemIndex === (data.length - 1)}]"
                                        v-for="(columnDef, index) in columnDefs"
                                        :key="index"
                                        :style="columnDef.style"
                                    >


                                        <div
                                            class="td-renderer"
                                            v-if="columnDef.cellRenderer && setCellRenderer(columnDef, item)">
                                            {{ applyCellRenderer(itemIndex, columnDef, item) }}
                                        </div>

                                        <div
                                            class="td-renderer"
                                            v-if="columnDef.cellRenderer && !setCellRenderer(columnDef, item)"
                                            v-html="applyCellRenderer(itemIndex, columnDef, item)"></div>

                                        <p class="td-text" v-else-if="item[columnDef.field] || item[columnDef.field] == 0">
                                            <template v-if="columnDef.currency">{{formatCurrency(item[columnDef.field])}}</template>
                                            <template v-else-if="columnDef.percent">{{formatPercent(item[columnDef.field])}}</template>
                                            <template v-else>{{ item[columnDef.field] }}</template>
                                        </p>

                                        <p v-else>---</p>

                                        <ld-tooltip :parent="tooltipParent" v-if="!columnDef.hiddenTooltip && columnDef.field !== 'acao' && columnDef.headerName !== 'ação' && item[columnDef.field] !== '---' && (item[columnDef.field] || columnDef.cellRenderer)">
                                            <template v-slot:target>
                                                <div class="button-ver">
                                                    <feather-icon icon="EyeIcon" class="icon-button-ver" svgClasses="h-4 w-4"/>
                                                </div>
                                            </template>

                                            <template v-slot:content>
                                                <div
                                                    v-if="columnDef.cellRenderer && setCellRenderer(columnDef, item)">
                                                    {{ applyCellRenderer(itemIndex, columnDef, item) }}
                                                </div>

                                                <div
                                                    v-if="columnDef.cellRenderer && !setCellRenderer(columnDef, item)"
                                                    v-html="applyCellRenderer(itemIndex, columnDef, item)"></div>

                                                <p v-else>
                                                    <template v-if="columnDef.currency">{{formatCurrency(item[columnDef.field])}}</template>
                                                    <template v-else-if="columnDef.percent">{{formatPercent(item[columnDef.field])}}</template>
                                                    <template v-else>{{ item[columnDef.field] }}</template>
                                                </p>
                                            </template>
                                        </ld-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                            </transition>

                            <tbody class="no-register" v-if="data && !data.length">
                                <p>Nenhum registro encontrado</p>
                            </tbody>


                            <tfoot v-if="hasFooter" class="table-tfoot" v-show="data && data.length">
                                <tr>
                                    <th
                                        class="toggle-foot"
                                        :class="{'toggle-down': hideTFoot}"
                                    >
                                        <div class="table-foot-content">
                                            <button
                                                @click="hideTFoot = !hideTFoot"
                                                class="flex justify-between items-center"
                                                type="button"
                                            >
                                                <div class="flex items-center">
                                                    <p>{{ toggleFooterName }}</p>
                                                    <vx-tooltip class="flex items-center" color="dark" :text="footerInfo" position="right">
                                                        <feather-icon
                                                            class="toggle-icon-info ml-1"
                                                            v-if="hasFooterInfo"
                                                            icon="InfoIcon"
                                                            :svg-classes="['h-5 w-5']"
                                                        />
                                                    </vx-tooltip>
                                                </div>
                                                <feather-icon
                                                    class="ml-1"
                                                    v-if="hasFooterInfo"
                                                    :icon="hideTFoot ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                                                    :svg-classes="['h-5 w-5']"
                                                />
                                            </button>
                                        </div>
                                    </th>
                                </tr>
                                <tr v-if="!hideTFoot">
                                    <th
                                        class="table-foot-first-line"
                                        :class="[
                                            filterColumnPrefix + removeWhiteSpace(columnDef.field),
                                            setColumnVisibility(columnDef)
                                        ]"
                                        :style="columnDef.style"
                                        v-for="(columnDef, index) in columnDefs"
                                        :key="index">
                                        <div :class="{'border-on': index === (columnDefs.length - 1)}" class="table-foot-content">
                                            <p v-if="columnDef.currency">
                                                {{ formatCurrency( footerDataFirstLine[columnDef.field] ) }}

                                            </p>

											<p v-else-if="columnDef.time">
												{{ formatTime(footerDataFirstLine[columnDef.field]) }}
											</p>

											<p v-else>{{ footerDataFirstLine[columnDef.field] }}</p>
                                        </div>
                                    </th>
                                </tr>
                                <tr v-if="!hideTFoot">
                                    <th
                                        class="table-foot-second-line"
                                        :class="[
                                            filterColumnPrefix + removeWhiteSpace(columnDef.field),
                                            setColumnVisibility(columnDef)
                                        ]"
                                        :style="columnDef.style"
                                        v-for="(columnDef, index) in columnDefs"
                                        :key="index">
                                            <div :class="{'border-on': index === (columnDefs.length - 1)}" class="table-foot-content">


												<p v-if="columnDef.currency">
													{{formatCurrency( footerDataSecondLine[columnDef.field] )}}
												</p>

												<p v-else-if="columnDef.time">
													{{ formatTime(footerDataSecondLine[columnDef.field]) }}
												</p>

												<p v-else>
													{{ footerDataSecondLine[columnDef.field] }}
												</p>
                                            </div>
                                    </th>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                </div>

                <div class="table-footer">
                    <div class="ld-table-pagination">
                        <ld-pagination
                            :currentPage.sync="pagination.currentPage"
                            :numberPages="pagination.totalPages"/>
                    </div>
                    <slot name="footer"/>
                </div>

                <div :id="`loading-table-${hashForClassLoading}`" class="loading-table" v-show="!data || isFiltering"></div>
            </vs-card>
        </ld-fullscreen-expansion>
    </div>
</template>

<script>
import LdPagination from "./utils/ld-pagination/LdPagination.vue";
import LdFullscreenExpansion from '@/components/ld-fullscreen-expansion/LdFullscreenExpansion'
import LdFullscreenToggleExpandButton from '@/components/ld-fullscreen-expansion/components/LdFullscreenToggleExpandButton'

import StringHelper from '../../helpers/StringHelper';

import configs from '../../config';

import CryptoJS  from "crypto-js";
import Jquery from "jquery";

import moment from 'moment';
import DAO from '../../DAO/DAO';

export default {
    name: "LdTable",
    components: {
        LdPagination,
        LdFullscreenExpansion,
        LdFullscreenToggleExpandButton,
    },
    data() {
        return {
            count: null,
            data: null,
            filtersData: {},
            cleanFilters: {},
            sortData: {},
            pagination: {
                totalPages: 0,
                maxPageNumbers: 0,
                pageSize: 10,
                currentPage: 1
            },
            filterColumnPrefix: 'column',
            filterColumn: [],
            hashForClassLoading: null,
            firstLoading: true,
            isResizing: false,
            lastParams: null,
            getWithFilter: null,
            isFiltering: false,
            isSettingFilters: false,
            isSettingSort: false,
            hideTFoot: false,
            debounceSetFilterThTp: null,
            parentId: null,
            ldTableKey: null,
            filtersFields: {},
        };
    },
    props: {
		tableQueryKey: {
			required: false,
			type: String,
		},
        loadingText: {
            type: String,
            required: false
        },
        columnDefs: {
            type: Array,
            required: true
        },
        lineDefs: {
            type: Object,
            required: false,
            default: () => {return {}},
        },
        filters: Object,
        initialData: Object,
        loadingContainer: String,
        getData: {
            type: Function,
            required: true
        },
        configsDetail: {
            type: Object,
            default: null
        },
        handlerClickItem: {
            type: Function,
            default: null
        },
        update: {
            type: Object,
        },
        clearFilters: {
            type: Object
        },
        onClearFilters: {
            type: Function,
        },
		canClearFilters: {
			type: Boolean,
			default: false,
		},
        footerKeyData: {
            type: Array,
        },
        footerData: {
            type: Object,
        },
        hasFooter: {
            type: Boolean
        },
        toggleFooterName: {
            type: String,
        },
        hasFooterInfo: {
            type: Boolean
        },
        footerInfo: {
            type: String,
            default: "",
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        expandedParentId: {
            type: String,
            required: false,
        },
        withoutQueryRoute: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
         filtersData: {
            // eslint-disable-next-line no-unused-vars
            handler: async function (filters, oldFilters) {
                const params = this.getParams(filters, this.sortData);

                if (this.isSettingFilters || this.isSettingSort) {
                    return null;
                }

                this.isFiltering = true;

                if (this.getWithFilter) {
                    clearTimeout(this.getWithFilter);
                }

                this.getWithFilter = setTimeout(async () => {
                    this.isFiltering = false;
                    this.setRouteQuery(params);
                    await this._getData(params);
                }, 600);
            },
            deep: true
        },
         sortData: {
            // eslint-disable-next-line no-unused-vars
            handler: async function (sort, oldsort) {
                if (!this.isSettingSort) {
                    const params = this.getParams(this.filtersData, sort);
                    this.setRouteQuery(params);
                    await this._getData(params);
                }
            },
            deep: true
        },
        "pagination.currentPage": function() {
            const params = this.getParams(this.filtersData, this.sortData);
            this.setRouteQuery(params);
            this._getData(params);
        },
        update() {
            if (this.getData) {
                const params = this.getParams(this.filtersData, this.sortData);
                this.setRouteQuery(params);
                this._getData(params);
            }
        },
        filters() {
            this.filtersData = this.filters;
        },
        clearFilters() {
            this.resetFilter();
        },
    },
    computed: {
        footerDataFirstLine() {
            if (this.footerData && this.footerKeyData && this.footerKeyData.length) {
                return this.footerData[this.footerKeyData[0]]
            }

            return {};
        },
        footerDataSecondLine() {
            if (this.footerData && this.footerKeyData && this.footerKeyData.length) {
                return this.footerData[this.footerKeyData[1]]
            }

            return {};
        },
        tooltipParent() {
            let parent = this.$el.querySelector(".ld-table-content");

            if (parent) {
                return parent;
            }

            return "body";
        },
        offsetCurrentPage() {
            const { pageSize, currentPage } = this.pagination;

            return pageSize * (currentPage - 1);
        },
        columnFilterList() {

            const columns = this.columnDefs.map(column => {
                return {
                    key: column.headerName,
                    value: this.removeWhiteSpace(column.field),
                    disabled: column.filterColumnDisabled
                };
            });

            const filters = [{
                key: 'Todas as colunas',
                value: columns
            }];

            return filters;
        },
        hasFilterColumns() {
            return this.columnDefs.some(column => {
                return column.filter !== false;
            });
        },
        hasFilter() {
            const filters = Object.values(this.filtersData).filter(value => {
                if (Array.isArray(value)) {
                    return value.length;
                }

                return value !== null && value !== undefined;
            });

            return filters.length || this.canClearFilters;
        },
        ldTableId() {
            if (this.$el && this.$el.id) return this.$el.id;

            return `ld-table-id-${this.ldTableKey}`;
        },
    },
    methods: {
		formatTime(value) {
			return moment.duration({
				milliseconds: value
			}).format("hh[h]:mm[m]:ss[s]", {trim: false});
		},
		formatPercent(string) {
			return StringHelper.formatPercent(string);
		},
		formatCurrency(string) {
			return StringHelper.formatCurrency(string);
		},
		removeWhiteSpace(string) {
			return StringHelper.removeWhiteSpace(string);
		},
        trCustomClasses(data) {
            if (this.lineDefs.getCustomClasses) {
                return this.lineDefs.getCustomClasses(data);
            }

            return {};
        },
        setLdTableKey() {
            this.ldTableKey = CryptoJS.lib.WordArray.random(32).toString();
        },
        getParentId() {
            if (this.expandedParentId) {
                return this.expandedParentId;
            }

            if (this.expanded) {
                if (this.$el && this.$el.parentElement && this.$el.parentElement.id) {
                    return  `#${this.$el.parentElement.id}`;
                }

                throw Error("the prop expanded is true, then the element parent should have an id.");
            }

            return "";
        },
        setFiltersThTop() {
            return new Promise(resolve => {
                const headerTh = this.$el.querySelector('.row-column-headings th');

                if (headerTh) {
                    const filtersTh = this.$el.querySelectorAll('.row-filters th');

                    if (filtersTh) {
                        filtersTh.forEach(th => {
                            th.style.top = headerTh.clientHeight + 'px';
                        });
                    }
                }

                resolve();
            });
        },
        resetFilter() {
            this.filtersData = JSON.parse(JSON.stringify(this.cleanFilters));

            const filterInputs = document.querySelectorAll('.row-filters input');

            if (filterInputs) {
                filterInputs.forEach(input => {
                    input.value = null;
                });
            }

			if (this.onClearFilters && (this.canClearFilters || this.filterInputs)) {
				this.onClearFilters();
			}
        },
        isLastParams(params) {
            if (!this.lastParams) {
                return false;
            }

            return JSON.stringify(this.lastParams) === JSON.stringify(params);
        },
        setHashForClassLoading() {
            const randomWord = CryptoJS.lib.WordArray.random(32).toString();

            this.hashForClassLoading = randomWord;
        },
        setloading() {
            try {
                this.$vs.loading({
                    ...configs.loadingConfigs,
                    textAfter: "true",
                    container: `#loading-table-${this.hashForClassLoading}`,
                    text: this.loadingText ? this.loadingText : "Aguarde",
                });
            // eslint-disable-next-line no-empty
            } catch (error) {}
        },
        removeLoading() {
            this.$vs.loading.close(`#loading-table-${this.hashForClassLoading} > .con-vs-loading`);
        },
        setColumnVisibility(column) {
            const field = this.removeWhiteSpace(column.field);

            if (this.filterColumn.includes(field)) {
                return '';
            }

            return 'hidden';
        },
        setQueryFilterColumn() {
            const filterColumn = this.filterColumn.join();
            const query = this.getRouteQuery();
            this.setRouteQuery({ ...query, column: filterColumn });
        },
        onToggleSingleColumn() {
            this.setQueryFilterColumn();
        },
        onToggleMultipleColumns() {
            this.setQueryFilterColumn();
        },
        getRouteQuery() {
            const query = new URLSearchParams(window.location.search);
            const queries = {};

            query.forEach((value, key) => {

                if (value !== null && value !== undefined && value.trim() !== "") {
                    const isNumber = !(/\D/g.test(value));
                    const isBoleean = /^false$|^true$/.test(value);

                    if (isBoleean) {
                        queries[key] = value === 'true';
                    } else if (isNumber) {
                        queries[key] = parseFloat(value);
                    } else {
                        queries[key] = value;
                    }
                }

            });

            return queries;
        },
        setRouteQuery(query) {
            if (this.withoutQueryRoute) return;

            let queries = new URLSearchParams(window.location.search);

            this.columnDefs.forEach(columnDef => {
                const column = this.filtersFields[columnDef.field] || columnDef.field;

                if ((query[column] === null || query[column] === undefined) && queries.has(column)) {
                    queries.delete(column);
                }
            });

            Object.keys(query).forEach(key => {
                if (query[key] !== null && query[key] !== undefined) {
                    queries.set(key, query[key]);
                }
            });

			if (queries) {
				queries = queries.toString();
				const lastPath = window.location.pathname.split('/').pop();
				window.history.replaceState(null, null, `${lastPath}?${queries}`);
			}

			if (this.tableQueryKey && typeof this.tableQueryKey === "string") {
				DAO.setProperty(this.tableQueryKey, queries);
			}
        },
        async _getData(params={}, _data) {

            this.data = null;
            this.lastParams = JSON.parse(JSON.stringify(params));
            let data = [];
            let count = 0;

            if (!_data) {

                const response = await this.getData(params);

                if (response) {
                    data = response.data;
                    count = response.count;
                }
            } else {
                data = _data.data;
                count = _data.count;

                if (this.loadingContainer) {
                    this.$vs.loading.close(this.loadingContainer);
                }
            }

            if (!this.isLastParams(params)) {
                return null;
            }

            this.lastParams = null;
            this.data = data;
            this.count = count;
            this.setTotalPages(count);

            if (data.length === 0 && this.pagination.currentPage > 1) {
                this.pagination.currentPage = 1;
            }

        },
        setTotalPages(dataLength) {
            if (dataLength <= this.pagination.pageSize) {
                this.pagination.totalPages = 1;
            } else {

                let totalPages = dataLength / this.pagination.pageSize;

                if (Number.isInteger(totalPages)) {
                    this.pagination.totalPages = totalPages;
                } else {
                    this.pagination.totalPages = parseInt(totalPages) + 1;
                }

            }
        },
        setFiltersData() {
            this.isSettingFilters = true;

            const query =  this.withoutQueryRoute ? {} : this.getRouteQuery();

            if (this.filters) {
                this.filtersData = this.filters;
                this.cleanFilters = this.filters;
            } else {
                this.columnDefs.forEach(columnDef => {
                    const filterName = this.filtersFields[columnDef.field] || columnDef.field;

                    this.$set(this.filtersData, filterName, query[filterName]);
                    this.$set(this.cleanFilters, filterName, null);
                });
            }

            setTimeout(() => {
                this.isSettingFilters = false;
            }, 0);
        },
        setFiltersFields() {
            this.columnDefs.forEach(columnDef => {
                this.$set(this.filtersFields, columnDef.field, columnDef.filterField);
            });
        },
        setFilterData(filterName, value) {
            this.$set(this.filtersData, filterName, value);
        },
        getParams(filters={}, sortModel={}) {

            const params = {};
            const { pageSize } = this.pagination;
            const { offsetCurrentPage } = this;

            if (Object.values(sortModel).length) {
                params["ordering"] = Object.values(sortModel).join();
            }

            Object.keys(filters).map((filter) => {
                let value = filters[filter]
                const filterName = this.filtersFields[filter] || filter;

                if (value !== null && value !== undefined) {
                    value = JSON.parse(JSON.stringify(value));

                    if (Array.isArray(value)) {
                        params[filterName] = value.join();
                    } else {
                        params[filterName] = value;
                    }

                }
            });

            if (pageSize) {
                params["limit"] = pageSize;
            }

            if (offsetCurrentPage || offsetCurrentPage == 0) {
                params["offset"] = offsetCurrentPage;
            }

            if (Object.keys(this.filterColumn).length) {
                params['column'] = this.filterColumn.join();
            }

            const query = new URLSearchParams(window.location.search);
            if (query.has('element_expanded')) {
                params['element_expanded'] = query.get('element_expanded');
            }

            if (query.has('periodo')) {
                params['periodo'] = query.get('periodo');
            }

            return params;
        },
        selectItem(item) {
            if (this.configsDetail) {

                try {
                    const {
                        routeName,
                        fieldsParams,
                        cleanParams
                    } = this.configsDetail;
                    const params = {};

                    Object.keys(fieldsParams).forEach(param => {
                        const fieldName = fieldsParams[param];
                        const fieldValue = item[fieldName];

                        params[param] = fieldValue;
                    });

                    if (this.handlerClickItem) {
                        try {
                            this.handlerClickItem(item);

                        } catch (error) {

                            console.log(error);
                        }
                    }

                    this.$navigate({ name: routeName, params, cleanParams });

                } catch (error) {
                    console.log(error);
                }

            } else if (this.handlerClickItem) {
                try {
                    this.handlerClickItem(item);

                } catch (error) {

                    console.log(error);
                }
            }
        },
        setPageSize(value) {
            this.pagination.pageSize = value;
            this.pagination.currentPage = 1;
            const params = this.getParams(this.filtersData, this.sortData);
            this.setRouteQuery(params);
            this._getData(params);
        },
        setSort(field) {
            if (!this.isResizing) {
                const sort = this.sortData[field];

                if (!sort) {
                    this.sortData[field] = field;

                } else if (sort && sort === ('-' + field)) {
                   delete this.sortData[field]

                } else {
                    this.sortData[field] = '-' + field;
                }

                this.$set(this.sortData, 'update', 'update');
                delete this.sortData.update
            }
        },
        setCellRenderer(columnDef , item) {

            const params = {
                value: item[columnDef.field],
                data: item
            }

            const element = columnDef.cellRenderer(params);

            return typeof element === 'object';

        },
        applyCellRenderer(idTr, columnDef , item) {

            const params = {
                value: item[columnDef.field],
                data: item
            }

            if (columnDef.cellRenderer && typeof columnDef.cellRenderer === 'function') {

                const element = columnDef.cellRenderer(params);

                if (typeof element === 'string') {
                    return element;
                }

                setTimeout(() => {
                    const $tr = this.$el.querySelector(`tr#index${idTr}`);

                    if ($tr) {

                        const $td = $tr.querySelector(`td.${columnDef.field}`);

                        $td.childNodes.forEach($element => {
                            if ($element.classList && !$element.classList.contains('button-ver')) {
                                $element.remove();
                            }
                        });

                        $td.innerHTML = '';
                        $td.appendChild(element);

                    }
                }, 0);

            } else {
                return '';
            }

        },
        applyFilterRenderer() {

            setTimeout(() => {

                this.columnDefs.forEach(columnDef => {
                    const filterName = this.filtersFields[columnDef.field] || columnDef.field;

                    if (columnDef.customFilter) {

                        const $container = this.$el.querySelector(`#customFilter${filterName}`);

                        const params = {
                            setFilter: this.setFilterData,
                            filterName,
                            value: this.filtersData[filterName]
                        }

                        if ($container && columnDef.customFilter && typeof columnDef.customFilter === 'function') {
                            $container.appendChild(columnDef.customFilter(params));
                        }
                    }

                });

            }, 0);
        },
        setFilterColumn() {
            const { column } = this.getRouteQuery();

            if (!this.withoutQueryRoute && column) {
                this.filterColumn = column.split(',');
            } else {
                this.filterColumn = this.columnDefs.filter(column => {
                    return !column.hidden
                })
                .map(column => {
                    return this.removeWhiteSpace(column.field);
                });
            }
        },
        resizableTable() {
            const $this = this;
            let startX = false;
            let startWidth = false;
            let $handle = false;
            let $table = false;
            let pressed = false;

            Jquery(document).on({
                mousemove: function mousemove(event) {
                    if (pressed) {
                        $handle.css("min-width", `${startWidth + (event.pageX - startX)}px`);
                        $handle.width(startWidth + (event.pageX - startX));

                        $this.setFiltersThTop();
                    }
                },
                mouseup: function mouseup() {
                    if (pressed) {
                        $table.removeClass('resizing');
                        $handle.removeClass('th-resizing');
                        pressed = false;

                        setTimeout(() => {
                            $this.isResizing = false;
                        }, 100);
                    }
                }
            }).on('mousedown', '.th-column-headings .resize-area', function mousedown(event) {
                $this.isResizing = true;
                $handle = Jquery(this).closest('.th-column-headings');
                $handle.addClass('th-resizing');
                pressed = true;
                startX = event.pageX;
                startWidth = $handle.width();

                $table = $handle.closest('.table-resizable').addClass('resizing');
            });
        },
        setInitialCurrentPage() {
            if (this.withoutQueryRoute) return;

            const { offset } = this.getRouteQuery();

            if (offset && offset > 0) {
                this.pagination.currentPage = (offset / this.pagination.pageSize) + 1;
            } else {
                this.pagination.currentPage = 1;
            }
        },
        setInitialPageSize() {
            if (this.withoutQueryRoute) return;

            const { limit } = this.getRouteQuery();
            this.pagination.pageSize = limit || 10;
        },
        setInitialSortData() {
            if (this.withoutQueryRoute) return;

            this.isSettingSort = true;

            let { ordering } = this.getRouteQuery();

            if (ordering) {
                ordering = ordering.split(',');
                const sortData = {};

                ordering.forEach(data => {
                    // eslint-disable-next-line no-useless-escape
                    const column = data.replace(/\-/g, '');
                    sortData[column] = data;
                });

                this.sortData = sortData;
            }

            setTimeout(() => {
                this.isSettingSort = false;
            }, 0);
        },
		retrieveQueries() {
			if (this.tableQueryKey && typeof this.tableQueryKey == "string") {
				const queries = DAO.getProperty(this.tableQueryKey);
				if (queries) {
					const lastPath = window.location.pathname.split('/').pop();
					window.history.replaceState(null, null, `${lastPath}?${queries}`);
				}
			}
		},
    },
    beforeMount() {
        this.setHashForClassLoading();
        this.setLdTableKey();
		this.retrieveQueries();
    },
    mounted() {

        this.setFiltersFields();
        this.setFiltersData();
        this.setInitialSortData();
        this.setInitialPageSize();
        this.setInitialCurrentPage();
        this.setFilterColumn();

        const params = this.getParams(this.filtersData, this.sortData);

        this.setRouteQuery(params);

        this.applyFilterRenderer();
        this.setloading();

        this._getData(params, this.initialData).then(() => {
            this.firstLoading = false;
            this.$emit("update:initialData", null);
            this.resizableTable();
        });

        this.$nextTick(() => {
            // eslint-disable-next-line no-unused-vars
            const resizeObserver = new ResizeObserver(entries => {
                setTimeout(this.setFiltersThTop, 100);
            });
            resizeObserver.observe(this.$el);
        });

        this.parentId = this.getParentId();
    },
    beforeDestroy() {
        this.removeLoading();
    },
    updated() {
        this.$nextTick(() => {
            if (this.debounceSetFilterThTp) {
                clearTimeout(this.debounceSetFilterThTp);
            }
            this.debounceSetFilterThTp = setTimeout(
                this.setFiltersThTop,
                150,
            );
        })
    }
};
</script>

<style lang="scss">

.dropdown-table-page {
    z-index: 500001 !important;
}

.fade-down-enter-active{
  transition: opacity 50ms;
}

.fade-down-leave-active {
  transition: opacity 50ms;
}

.fade-down-leave-to {
    opacity: 0;
}

.fade-down-enter {
  opacity: 0;
//   transform: translateY(-1%);
}

.target-expand:not(.expand-disabled) {
    .ld-table {
        padding-left: 0;
        padding-right: 0;

        & > .vs-card--content {
            padding-left: 20px;
            padding-right: 30px;
        }
    }
}

.ld-table {
    // height: calc(100vh - 202px);
    min-height: 433px;
    margin-bottom: 0 !important;
    padding: 20px 30px 20px 20px;

    .table-slot {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        flex: 1;
        min-height: 50px;
        margin-bottom: 1rem;

        & > div:first-child {
            position: sticky;
            right: 21px;
        }
    }

    .filter-column {
        width: 200px;
        margin-right: 5px;
    }

    .vs-card--content {
        position: relative;
        height: 100%;
    }

    .ld-table-content {
        position: relative;
        display: flex;
        width: 100%;
        align-items: flex-start;
        // height: calc(100% - 126px);
        // overflow: auto;

        &.loading-data {
            min-height: 473px;
        }
    }

    .hidden {
        display: none !important;
    }

    .icon-order {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;
    }

    table {
        width: calc(100% - 3px);
        table-layout: auto;

        tbody {

            &.no-register {
                position: absolute;
                left: 50%;
                display: block !important;
                margin-top: 50px;
                transform: translateX(-50%);
            }
        }

        tbody tr {
            transition: background 0.2s ease;

            &.no-click {
                cursor: default;

                .con-vs-avatar {
                    cursor: default !important;
                }
            }

            &.click {
                cursor: pointer !important;

                .con-vs-avatar {
                    cursor: pointer !important;
                }
            }

            &:hover {
                background: #f2f2f2;
            }
        }

        tr {

            &.row-column-headings {
                th {
                    top: 0;
                    padding: 0 !important;
                    font-size: 0.8rem;
                    color: rgba(0, 0, 0, 0.54);
                    transition: background 0.5s ease, border 0.5s ease;
                    cursor: pointer;
                    border-bottom: none !important;

                    -webkit-touch-callout: none;
                    -webkit-user-select: none;
                    -khtml-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;

                    .thead-th-content {
                        display: flex;
                        align-items: flex-end;
                        height: 100%;
                        padding: 6px 14px;
                        border-right: 3px dashed #fff;
                        border-bottom: 1px solid #e2e2e2;

                        &:hover {
                            background: #f2f2f2;
                            border-right-color: #e0dfdf;
                        }

                        &:focus {
                            border-right-color: #e0dfdf;
                        }
                    }

                    p {
                        width: 95%;
                    }

                    .resize-area {
                        position: absolute;
                        top: 0;
                        right: -3px;
                        display: block;
                        width: 5px;
                        height: 100%;
                        cursor: col-resize !important;
                    }
                }
            }

            &.row-filters {
                th {
                    top: 51px;
                    padding: 0 !important;
                    border-bottom: none !important;

                    .thead-th-content {
                        display: flex;
                        height: 100%;
                        padding: 6px 14px;
                        border-bottom: 1px solid #e2e2e2;
                    }
                }
            }
        }

        &,
        th,
        td {
            border-collapse: collapse;
        }

        th {
            height: 51px;

             & > div,
             .thead-th-content > div,
             .vs-con-input-label {
                width: 100%;
                margin: 0 !important;
            }
        }

        th, td {
            position: relative;
            min-width: 51px;
            border-bottom: 1px solid #e2e2e2;
        }

        td {
            padding: 6px 14px;
            height: 47px;
            font-size: 14px;

            & .td-renderer {
                width: calc(100% - 18.88px);
            }

            & .td-text,
            & .td-renderer p {
                width: calc(100% - 19px);
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: left;
            }

            .button-ver {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                visibility: hidden;
                width: 12.88px;
                border: none;
                background: transparent;
                cursor: pointer;
                margin: 0 0 0 6px;
                transition: visibility .2s ease;

                .icon-button-ver {
                    color: #28C76F;
                }
            }

            &:hover .button-ver,
            .ld-tooltip .show .button-ver {
                visibility: visible;
            }

            &:not(.ld-tooltip) {
                max-width: 0;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }

        .avatar-table {
            width: 40px;
            min-width: 40px;
            height: 40px;
            min-height: 40px;

            &.no-image {
                background: rgb(195, 195, 195);
            }
        }

        thead th,
        tfoot th {
            position: -webkit-sticky;
            position: sticky;
        }

        tfoot th {
            z-index: 3000;
        }

        thead th {
            z-index: 3002;
        }


        thead,
        thead tr,
        thead th {
            background: #fff;
        }

        tfoot th {
            height: 22px;
            border: none !important;
            padding: 0 !important;

            .table-foot-content {
                width: 100%;
                height: 100%;
                padding: 6px 10px;
                padding-top: 5px;
                padding-bottom: 3px;
                border-top: 1px solid rgba(0, 0, 0, .2);
                border-right: 1px solid rgba(0, 0, 0, .2);
            }

            .table-foot-content.border-on {
                border-left: 1px solid rgba(0, 0, 0, .2) !important;
            }

            p {
                font-family: Montserrat !important;
                font-weight: bold !important;
                font-size: 11px !important;
                color: #626262 !important;
            }
        }

        .table-foot-first-line {
            bottom: 25.6px;
            background: #F7F7F7;
        }

        .table-foot-second-line {
            bottom: 0px;
            background: #ECECEC;

            .table-foot-content {
                border-bottom: 1px solid rgba(0, 0, 0, .2);
            }
        }

        .toggle-foot {
            bottom: 50.5px !important;
            left: 0;
            overflow: visible;
            height: 23px;
            padding: 0;
            padding-bottom: 2px;
            border-radius: 10px 10px 0px 0px;
            cursor: pointer;
            z-index: 3001;

            &.toggle-down {
                bottom: 0 !important;
            }

            .table-foot-content {
                padding: 6px 10px;
                height: 100%;
                width: 100px;
                background: #F7F7F7;
                border: 1px solid rgba(0, 0, 0, .2);
                // border-bottom: 1px solid #606060;
                border-radius: 10px 10px 0px 0px;

                button {
                    width: 100%;
                    height: 100%;
                    margin: 0;
                    padding: 0;
                    border: none;
                    background: transparent;
                    outline: none !important;
                    cursor: pointer;

                    &:hover, &:focus {
                        outline: none !important;
                        background: transparent;
                    }
                }
            }

            svg {
                stroke: #606060;
            }

            .toggle-icon-info svg {
                fill: #606060;

                line {
                    stroke: #fff;
                }
            }
        }
    }

    .table-footer {
        position: relative;
        padding: 20px;
        background: #fff;
    }

    .ld-table-pagination {
        position: relative;
    }

    .loading-table {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        .con-vs-loading {
            position: absolute;
            flex-direction: column-reverse;
        }

        h4 {
            font-size: 1rem;
        }
    }

    .table-resizable {
        &.resizing {
            cursor: col-resize;
            user-select: none;

            .th-column-headings {
                cursor: col-resize !important;
                border-right-color: #ffffff !important;
                background: #ffffff !important;
            }

            .th-resizing {
                background: #f2f2f2 !important;
                border-right-color: #e0dfdf !important;
            }
        }
    }

    @media (max-width: 659px) {
        .button-clear-filter {
            margin-top: 16px;
        }
    }
}

.popup-show-cell {
    z-index: 53001 !important;

    .con-vs-avatar {
        background: #c3c3c3;
    }
}

</style>
